export default "__VITE_ASSET__v5H1aZCE__"